
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Concrete from './sections/Concrete';
import Steelwork from './sections/Steelwork';
import Blockwork from './sections/Blockwork';
import Formwork from './sections/Formwork';
import AboutUs from './pages/AboutUs';
import FAQ from './pages/FAQ';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Service from './pages/Service';
import Team from './pages/Team'
import Testimonials from './pages/Testimonials'
import NotFound from './pages/NotFound';
import ComingSoon from './pages/ComingSoon';
import Login from './pages/Login';
import Signup from './pages/Signup';
import TapeMeasurement from './sections/TapeMeasurement';


function App() {

return ( 

   <Router>
    <div className="App">
      
<Routes> 
  <Route path="/" element={ <Home/>}/>
   <Route path="/pages/AboutUs" element={ <AboutUs/>}/>
   <Route path="/pages/FAQ" element={ <FAQ/>}/>
   <Route path="/pages/Service" element={ <Service/>}/>
   <Route path="/pages/Team" element={ <Team/>}/>
    <Route path="/pages/Testimonials" element={ <Testimonials/>}/>
   <Route path="/pages/PrivacyPolicy" element={ <PrivacyPolicy/>}/>
   <Route path="/pages/Signup" element={ <Signup/>}/>
    <Route path="/pages/Login" element={ <Login/>}/>
    <Route path="/sections/TapeMeasurement" element={ <TapeMeasurement/>}/>
  <Route path="/sections/Concrete" element={ <Concrete/>}/>
  <Route path="/sections/Blockwork" element={ <Blockwork/>}/>
  <Route path="/sections/Formwork" element={ <Formwork/>}/>
  <Route path="/sections/Steelwork" element={ <Steelwork/>}/>
  <Route path="/pages/ComingSoon" element={ <ComingSoon/>}/>
   <Route path="*" element={ <NotFound/>}/>
  
  </Routes>   
    </div>
    </Router>

    
 );
}

export default App;
